import { get } from './get/index.tsx';

export const actions = { get };
